<div class="preview-wrapper" (click)="openModal()">
  <ng-container [ngSwitch]="meta.type">
    <!-- Image -->
    <ng-container *ngSwitchCase="'image'">
      <img
        *ngIf="resolvedUrl; else docFallback"
        [src]="resolvedUrl"
        [alt]="meta.fileName || 'Image'"
        class="preview-image"
      />
    </ng-container>

    <!-- Video -->
    <ng-container *ngSwitchCase="'video'">
      <div *ngIf="resolvedUrl; else docFallback" class="preview-video">
        <video [src]="resolvedUrl" muted playsinline></video>
        <div class="play-badge">
          <nw-icon type="play_arrow" [size]="12"></nw-icon>
        </div>
      </div>
    </ng-container>

    <!-- Document / other -->
    <div *ngSwitchDefault class="preview-doc">
      <nw-icon type="description" [size]="24" color="#6b7280"></nw-icon>
      <div class="filename">{{ meta.fileName || 'File' }}</div>
    </div>
  </ng-container>

  <!-- Fallback for image/video without a URL -->
  <ng-template #docFallback>
    <div class="preview-doc">
      <nw-icon [type]="meta.type === 'video' ? 'videocam' : 'image'" [size]="24" color="#6b7280"></nw-icon>
      <div class="filename">{{ meta.fileName || meta.type }}</div>
    </div>
  </ng-template>

  <!-- Upload progress overlay -->
  <div class="progress-overlay" *ngIf="uploadProgress !== null && uploadProgress < 100">
    <svg class="progress-ring" viewBox="0 0 36 36">
      <circle class="progress-bg" cx="18" cy="18" r="15.5" />
      <circle
        class="progress-bar"
        cx="18" cy="18" r="15.5"
        [attr.stroke-dasharray]="97.4"
        [attr.stroke-dashoffset]="97.4 - (97.4 * uploadProgress / 100)"
      />
    </svg>
    <div class="progress-text">{{ uploadProgress }}%</div>
  </div>
</div>

<!-- Full-screen preview modal -->
<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="modal-close" (click)="closeModal()">
      <nw-icon type="close" [size]="20" color="white"></nw-icon>
    </button>

    <img
      *ngIf="meta.type === 'image'"
      [src]="resolvedUrl"
      [alt]="meta.fileName || 'Image'"
      class="modal-image"
    />

    <video
      *ngIf="meta.type === 'video'"
      [src]="resolvedUrl"
      controls
      autoplay
      class="modal-video"
    ></video>
  </div>
</div>
